import React, { useRef, useEffect } from "react";
import { Box } from "@mui/material";

const styles = {
  container: {
    height: "100%",
    position: "relative",
  },
  wrapper: {
    height: "100%",
  },
  tableContainer: {
    overflow: "auto",
    borderRadius: "2px",
    maxHeight: "max-content",
    position: "relative",
    height: "400px",
    "&::-webkit-scrollbar": {
      width: "7px",
      height: "7px",
    },
    "&::-webkit-scrollbar-track-piece": {
      marginTop: "55px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      opacity: 0.3,
      borderRadius: "100px",
      "&:hover": {
        background: "#555",
      },
    },
  },
  tableWrapper: {
    position: "relative",
    width: "min-content",
    minWidth: "100%",
    height: "min-content",
    maxHeight: "100%",
  },
  table: {
    tableLayout: "fixed",
    display: "flex",
    flexDirection: "column",
  },
};

const TableWrap = ({ onLoadMore, children }) => {
  const tableRef = useRef(null);

  useEffect(() => {
    // const onScroll = (element) => {
    //   const isBottom =
    //     element.target.scrollHeight <=
    //     element.target.scrollTop + element.target.clientHeight + 100;
    //   if (isBottom) {
    //     onLoadMore();
    //   }
    // };
    // tableRef.current.addEventListener("scroll", onScroll);
    // return () => tableRef.current.removeEventListener("scroll", onScroll);
  });

  return (
    <Box sx={styles.container}>
      <Box sx={styles.wrapper}>
        <Box ref={tableRef} sx={styles.tableContainer}>
          <Box sx={styles.tableWrapper}>
            <Box sx={styles.table}>{children}</Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default TableWrap;
